import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=38ecc23c&scoped=true&"
import script from "./permissions.vue?vue&type=script&lang=ts&"
export * from "./permissions.vue?vue&type=script&lang=ts&"
import style0 from "./permissions.vue?vue&type=style&index=0&id=38ecc23c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ecc23c",
  null
  
)

export default component.exports